// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10OGe","comment":"styles_comment__1NkR2"};